import { createI18n } from 'vue-i18n'
import en from '@/locales/en.json'
import de from '@/locales/de.json'

const i18n = createI18n({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  // The keys treated as globals
  messages: {
    en,
    de
  }
})

export function getPreferredNavigatorLocale() {
  return navigator.languages[0]
}

export function setLocale(newLocale: string) {
  document.documentElement.lang = newLocale
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  i18n.global.locale.value = newLocale
}

export function getLocale(): string {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return i18n.global.locale.value
}

export default i18n
